module.exports = __webpack_public_path__ + "static/media/390JamesPBrawleyDrNW_2018-06-11_77.bc837940.jpg";